.cell {
  display: flex;
  align-items: center;
  padding: map.get($spacing-scale, 'sm') map.get($spacing-scale, 'md');
  background-color: var(--color-surface-alt);
  border-bottom: 1px solid var(--color-grey-soft);
}

.title {
  @include caption-medium;

  color: var(--color-text-secondary);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  flex: 1;
}
